import { useLocation, useNavigate } from "react-router-dom";
import { paths } from "../routes/paths";
import styles from "../styles/_layouts/side.module.scss";

const Side = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const path = location.pathname;

  const activeClasses = {
    dash: path === paths.dash ? styles.active : "",
    edit: path === paths.editContent ? styles.active : "",
    coupon: path === paths.coupon ? styles.active : "",
    mainAttractionDetail: path.includes("main-attraction") ? styles.active : "",
    constraints: path === paths.constraints ? styles.active : "",
    constraintsList: path === paths.constraintsList ? styles.active : "",
    shackClosing: path === paths.shackClosing ? styles.active : "",
    orders: path === paths.orders ? styles.active : "",
  };

  return (
    <aside
      className={styles.container}
      style={{ display: path === paths.login ? "none" : "flex" }}
    >
      <img src="/assets/logo.png" alt="logo" className={styles.logo} />
      <ul>
        <li className={activeClasses.dash} onClick={() => navigate(paths.dash)}>
          <img src="/assets/dashIcon.svg" alt="dashboard" />
          <p>Dashboard</p>
        </li>
        <li
          className={activeClasses.edit}
          onClick={() => navigate(paths.editContent)}
        >
          <img src="/assets/editHomeIcon.svg" alt="edit-home-content" />
          <p>Edit Content</p>
        </li>
        <li
          className={activeClasses.mainAttractionDetail}
          onClick={() => navigate(paths.mainAttractionDetail(1))}
        >
          <img src="/assets/mainAttractionIcon.svg" alt="main-attraction" />
          <p> Main attraction</p>
        </li>
        <li
          className={activeClasses.constraints}
          onClick={() => navigate(paths.constraints)}
        >
          <img src="/assets/constraintsIcon.svg" alt="constraints" />
          <p>Constraints</p>
        </li>
        <li
          className={activeClasses.constraintsList}
          onClick={() => navigate(paths.constraintsList)}
        >
          <img src="/assets/constraintsList.svg" alt="constraints-list" />
          <p>List of Constraints</p>
        </li>
        <li
          className={activeClasses.orders}
          onClick={() => navigate(paths.orders)}
        >
          <img src="/assets/orders.svg" alt="orders" />
          <p>Orders</p>
        </li>
        <li
          className={activeClasses.shackClosing}
          onClick={() => navigate(paths.shackClosing)}
        >
          <img src="/assets/closing.svg" alt="closing" />
          <p>Shack Closing</p>
        </li>
        <li
          className={activeClasses.coupon}
          onClick={() => navigate(paths.coupon)}
        >
          <img src="/assets/coupon.svg" alt="coupon" />
          <p>Add a coupon</p>
        </li>
      </ul>
    </aside>
  );
};

export default Side;
